import { useCallback } from 'react';
import { sdk } from 'sdk';
import { CTClientConfig } from 'shared/types/config/ClientConfig';

const useConfig = () => {
  const config = useCallback(async () => {
    const response = await sdk.callAction<CTClientConfig>({
      actionName: 'config/clientConfig',
    });

    return (response.isError ? {} : response.data) as CTClientConfig;
  }, []);

  const siteSelectorCountries = useCallback(async () => {
    const response = await config();
    return response.countries.filter((country) => country.showOnCountrySelector === true);
  }, []);

  return { config, siteSelectorCountries };
};

export default useConfig;
